import React, { useEffect } from 'react';

const AdSense = ({ 
  adSlot, 
  adFormat = 'auto',
  fullWidthResponsive = true,
  style = {},
  className = ''
}) => {
  useEffect(() => {
    try {
      // Push ad to AdSense queue
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense loading error:', error);
    }
  }, []);

  return (
    <div className={`adsense-container ${className}`} style={style}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={process.env.REACT_APP_ADSENSE_CLIENT_ID}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      />
    </div>
  );
};

// Predefined ad components for different placements
export const SidebarAd = ({ className = '' }) => (
  <AdSense
    adSlot="YOUR_SIDEBAR_AD_SLOT"
    adFormat="vertical"
    style={{ width: '300px', height: '600px' }}
    className={`sidebar-ad ${className}`}
  />
);

export const BannerAd = ({ className = '' }) => (
  <AdSense
    adSlot="YOUR_BANNER_AD_SLOT"
    adFormat="horizontal"
    style={{ width: '100%', height: '90px' }}
    className={`banner-ad ${className}`}
  />
);

export const SquareAd = ({ className = '' }) => (
  <AdSense
    adSlot="YOUR_SQUARE_AD_SLOT"
    adFormat="rectangle"
    style={{ width: '300px', height: '250px' }}
    className={`square-ad ${className}`}
  />
);

export const ResponsiveAd = ({ className = '' }) => (
  <AdSense
    adSlot="YOUR_RESPONSIVE_AD_SLOT"
    adFormat="auto"
    style={{ display: 'block' }}
    className={`responsive-ad ${className}`}
  />
);

export default AdSense;